.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: var(--hit-target);
  height: var(--hit-target);
  flex-shrink: 0;
  padding: 0;
  border: 1px solid transparent;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--color-text);
  transition:
    background-color var(--transition-fast),
    border-color var(--transition-fast);
}

.iconButton:hover:not(:disabled) {
  background: var(--color-surface-hover);
}

.iconButton:active:not(:disabled) {
  background: var(--color-primary-soft);
}

.iconButton:disabled {
  color: var(--color-text-disabled);
}

.pressed {
  background: var(--color-primary-soft);
  border-color: var(--color-primary);
  color: var(--color-primary);
}
